import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LiteralFormatterPipe } from './pipes/literalFormatter.pipe';

const components = [
    LiteralFormatterPipe
];
@NgModule({
    declarations: components,
    imports: [
        NgbModule,
        TranslateModule
    ],
    providers: [
        LiteralFormatterPipe
    ],
    exports: components
})

export class SharedModule { }
